import React, { useCallback, useEffect, useState } from 'react';
import { Typography, Box } from '@mui/material';
import Competences from '../components/team/Competences';
import ContentfulTeamMemberCard from '../components/team/ContentfulTeamMemberCard';
import { useTranslation } from 'react-i18next';
import { getEntries } from '../services/contentfulClient';
import { Grid } from '@mui/material';
import Seo from '../components/seo/Seo';

const contentfulLocale = (i18nLang) => {
  const normalizedLang = (i18nLang || '').split('-')[0];

  const i18nToContentfulLocale = {
    en: 'en-US',
    pl: 'pl-PL',
  };

  return i18nToContentfulLocale[normalizedLang] || normalizedLang;
};

const Team = () => {
  const { t, i18n } = useTranslation('team');
  const title = `Betonoki - ${t('ourTeam')}`;
  const description = t('metaDescription');

  const [teamMembers, setTeamMembers] = useState([]);
  const [boardMembers, setBoardMembers] = useState([]);
  const [administrativeMembers, setAdministrativeMembers] = useState([]);

  const fetchTeamData = useCallback(async () => {
    try {
      const locale = contentfulLocale(i18n.language);
      const baseQuery = { limit: 100, order: '-sys.createdAt', locale };
  
      const [teamRes, boardRes, adminRes] = await Promise.all([
        getEntries({ ...baseQuery, content_type: 'teamMember' }),      
        getEntries({ ...baseQuery, content_type: 'managementMember' }),   
        getEntries({ ...baseQuery, content_type: 'administrativeMember' }),
      ]);
  
      setTeamMembers(teamRes.items);
      setBoardMembers(boardRes.items);
      setAdministrativeMembers(adminRes.items);
    } catch (err) {
      console.warn('Contentful team:', err.message);
    }
  }, [i18n.language]);

  useEffect(() => {
    fetchTeamData();
  }, [fetchTeamData]);

  return (
    <>
      <Seo title={title} description={description} path="/team" image="/img/team/competences.jpg" />
      <Typography variant="h1">
        {t('ourTeam')}
      </Typography>

      <Competences/>


<Box sx={{ width: '100%' }}>
  <Grid container spacing={2} sx={{ mb: 4 }}>
    <Grid item xs={12} md={4}>
      <Typography variant="h5" sx={{ textAlign: 'center' }}>{t('boardLabel')}</Typography>
    </Grid>

    <Grid
      item
      md={4}
      sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}
    />
    <Grid item xs={12} md={2}>
      <Typography variant="h5" sx={{ textAlign: 'center' }}>{t('administrationLabel')}</Typography>
    </Grid>
  </Grid>

  <Grid container rowSpacing={4} columnSpacing={2} sx={{ mb: 8 }}>
    {boardMembers.map((member) => (
      <Grid item xs={6} sm={4} md={2} key={member.sys.id}>
        <ContentfulTeamMemberCard entry={member} />
      </Grid>
    ))}
    <Grid
      item
      md={4}
      sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}
    />
    {administrativeMembers.map((member) => (
      <Grid item xs={6} sm={4} md={2} key={member.sys.id}>
        <ContentfulTeamMemberCard entry={member} />
      </Grid>
    ))}
  </Grid>

  <Grid container rowSpacing={4} columnSpacing={2} sx={{ mb: 5 }}>
    <Grid item xs={12} sx={{mb: 4}}>
      <Typography variant="h5" sx={{ textAlign: 'center' }}>{t('coreTeamLabel')}</Typography>
    </Grid>
    {teamMembers.map((member) => (
      <Grid item xs={6} sm={4} md={2} key={member.sys.id}>
        <ContentfulTeamMemberCard entry={member} />
      </Grid>
    ))}
  </Grid>
</Box>
    </>
  );
};

export default Team;
